import { render, staticRenderFns } from "./BtnRestartFilter.vue?vue&type=template&id=57479932&"
import script from "./BtnRestartFilter.vue?vue&type=script&lang=js&"
export * from "./BtnRestartFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports